import { render, staticRenderFns } from "./sideItem.vue?vue&type=template&id=6abefb98&scoped=true"
import script from "./sideItem.vue?vue&type=script&lang=js"
export * from "./sideItem.vue?vue&type=script&lang=js"
import style0 from "./sideItem.vue?vue&type=style&index=0&id=6abefb98&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6abefb98",
  null
  
)

export default component.exports